import { render, staticRenderFns } from "./RetailerProfile.vue?vue&type=template&id=fdaa32ba"
import script from "./RetailerProfile.vue?vue&type=script&lang=js"
export * from "./RetailerProfile.vue?vue&type=script&lang=js"
import style0 from "./RetailerProfile.vue?vue&type=style&index=0&id=fdaa32ba&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports